var map = {
	"./lefafa_1_1.webp": 3797,
	"./lefafa_1_2.webp": 1932,
	"./lefafa_1_3.webp": 9009,
	"./lefafa_1_4.webp": 4901,
	"./lefafa_1_5.webp": 6730,
	"./lefafa_2_1.webp": 9283,
	"./lefafa_2_2.webp": 1549,
	"./lefafa_2_3.webp": 8664,
	"./lefafa_2_4.webp": 2356,
	"./lefafa_2_5.webp": 9483,
	"./lefafa_3_1.webp": 2785,
	"./lefafa_3_2.webp": 4349,
	"./lefafa_3_3.webp": 6577,
	"./lefafa_3_4.webp": 7108,
	"./lefafa_3_5.webp": 637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5692;